import styled from 'styled-components'

export const HorizontalScroll = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  
  overflow: scroll;
  
  & > * {
    flex: none;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`
